(function() {
    'use strict';

    class OutreachBannerService {
        constructor($scope, mwBannerService, SendgridService, $q, $http, $location, $timeout, NONVERIFY_DOMAINS){
            this.mwBannerService = mwBannerService;
            this.$scope = $scope;
            this.$q = $q;
            this.openOne = false;
            this.$http = $http;
            this.$location = $location;
            this.$timeout = $timeout;
            this.SendgridService = SendgridService;
            this.NONVERIFY_DOMAINS = NONVERIFY_DOMAINS;

            this.bannerPannelRef = {
                close:function(){}
            };
            this.$scope.$on('$locationChangeStart', function(e, next, current) {
                if(!(next.indexOf('influencers/contact/outreach') > -1 && current.indexOf('influencers/contact/outreach') > -1)) {
                    this.openOne = false;
                    this.bannerPannelRef.close();
                } else if (next.indexOf('?view=preview') > -1){
                    this.openOne = false;
                    this.bannerPannelRef.close();
                }
            }.bind(this));
            this.nonValidateDomains = {};
            this.getNonVerifiableDomains();
        }

        isEmpty(checkObj) {
            for(var key in checkObj) {
                if(checkObj.hasOwnProperty(key)) {
                    return false;
                }
            }
            return true;
        }

        getNonVerifiableDomains() {
            let deferred = this.$q.defer();
            this.$http.get(this.NONVERIFY_DOMAINS,{skipAuthInterceptor:true})
                .then((res) => {
                    res.data.domains.forEach((domain) =>{
                        this.nonValidateDomains[domain] = true;
                    });
                    deferred.resolve();
                })
                .catch(() => {
                    this.nonValidateDomains = {
                        'meltwater.com': true,
                        'aol.com': true,
                        'comcast.net': true,
                        'gmail.com': true,
                        'hotmail.co.uk': true,
                        'hotmail.com': true,
                        'hotmail.fr': true,
                        'msn.com': true,
                        'outlook.com': true,
                        'yahoo.com': true,
                        'mail.com': true
                    };
                    deferred.resolve();
                });
            return deferred.promise;
        }

        _areDomainsVerified(approvedSenderDomains, sendgridDomains, unverifiableDomains) {
            let allVerified = false;
            let verifiableApprovedSenderDomains = [];

            // lower case all domains for consistency
            approvedSenderDomains = approvedSenderDomains.map(function(approvedSenderDomain) {
                return approvedSenderDomain.toLowerCase();
            });
            sendgridDomains = sendgridDomains.map(function(sendgridDomain) {
                if(sendgridDomain.domain) {
                    sendgridDomain.domain = sendgridDomain.domain.toLowerCase();
                }

                return sendgridDomain;
            });
            unverifiableDomains = Object.keys(unverifiableDomains).map(function(unverifiableDomain) {
                return unverifiableDomain.toLowerCase();
            });

            // if we have a set of approved sender domains
            //   then remove any non-verifiable domains from the list of approved sender domains
            // if we don't have any approved sender domains, then we consider them "all verified"
            if (Array.isArray(approvedSenderDomains) && approvedSenderDomains.length) {
                verifiableApprovedSenderDomains = approvedSenderDomains.filter((domain) => {
                    return (unverifiableDomains.indexOf(domain) < 0);
                });

                // if we have a set of verifiable approved sender domains
                //   then check that every verifiable approved sender domain is verified in sendgrid
                // if we do not have any verifiable approved sender domains, then we consider them "all verified"
                if (Array.isArray(verifiableApprovedSenderDomains) && verifiableApprovedSenderDomains.length) {
                    if (Array.isArray(sendgridDomains) && sendgridDomains.length) {
                        allVerified = verifiableApprovedSenderDomains.every(function(verifiableApprovedSenderDomain) {
                            return sendgridDomains.some(function(sendgridDomainObject) {
                                if(sendgridDomainObject.domain === verifiableApprovedSenderDomain) {
                                    return sendgridDomainObject.isVerified;
                                } else {
                                    return false;
                                }
                            });
                        });
                    }
                } else {
                    allVerified = true;
                }
            } else {
                allVerified = true;
            }

            return allVerified;
        }

        checkVerifiedDomains(domainNames, config, sendgridDomainsArray){
            if (!sessionStorage.getItem('outreachBanner') && !this.openOne && domainNames.length > 0) {
                this.openOne = true;
                let domainsPromise;

                if(sendgridDomainsArray){
                    domainsPromise = this.$q.when(sendgridDomainsArray);
                } else {
                    domainsPromise = this.SendgridService.getCompanyDomains();
                }

                domainsPromise.then((sgDomains) => {
                    let allVerified = this._areDomainsVerified(domainNames, sgDomains, this.nonValidateDomains);

                    if (!allVerified) {
                        this.openApprovedSendersAlertBanner(config);
                    }
                })
                .catch(function () {});
            }
        }

        openApprovedSendersAlertBanner(config) {
            let openConfig = {
                bindToController: true,
                controller      : class BannerPanel {
                    constructor($mdToast, mdPanelRef, ACCOUNTS_APP_URL, $window, $translate) {
                        'ngInject';
                        this.mdPanelRef = mdPanelRef;
                        this.$mdToast = $mdToast;
                        this.ACCOUNTS_APP_URL = ACCOUNTS_APP_URL;
                        this.$window = $window;
                        this.$translate = $translate;
                        this.isCloseVisible = false;
                        //translation
                        this.description = this.$translate.instant('icm-outreach__email-banner--verify-domains-description');
                        this.settingsButton = this.$translate.instant('icm-outreach__email-banner--verify-domains-configure');
                        this.helpButton = this.$translate.instant('icm-outreach__email-banner--verify-domains-help');
                    }

                    close() {
                        //store the session so we don't show it again after user dismisses it
                        sessionStorage.setItem('outreachBanner', 'true');
                        this.mdPanelRef.close();
                    }

                    goToApprovedSenders() {
                        this.$window.open(this.ACCOUNTS_APP_URL + '/settings/email');
                    }

                    goToHelpPage() {
                        this.$window.open('https://support.meltwater.com/hc/en-us/articles/115009946947');
                    }
                },
                template: `
                <mw-banner type="\'info\'" on-close="$ctrl.close($event)">
                {{$ctrl.description}}
                    <mw-banner-actions>
                        <md-button class="outreachBannerButton mw-button mw-button--link md-primary " ng-click="$ctrl.goToApprovedSenders()">
                            {{$ctrl.settingsButton}}
                        </md-button>
                        <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.goToHelpPage()">
                            {{$ctrl.helpButton}}
                        </md-button>
                    </mw-banner-actions>
                </mw-banner>`,
                controllerAs: '$ctrl'
            };

            if(config && config.attachTo){
                openConfig.attachTo = config.attachTo;
            }

            if (this.bannerPannelRef) {
                // making sure there is only 1 outreach banner on page
                this.bannerPannelRef.close();
            }

            this.mwBannerService.open(openConfig).then(function (panelRef) {
                this.bannerPannelRef = panelRef;

                var currentUrl = this.$location.url();
                if(currentUrl.indexOf('influencers/contact/outreach') === -1) {
                    this.bannerPannelRef.close();
                } else if (currentUrl.indexOf('?view=preview') > -1 || (this.$location.search() && this.$location.search().view)){
                    this.bannerPannelRef.close();
                }

                if (this.$location.search() && this.$location.search().branch) {
                    this.$timeout(function() {
                        if (this.$location.search() && this.$location.search().view) {
                            this.bannerPannelRef.close();
                        }
                    }.bind(this), 600);
                }
            }.bind(this));
        }

        openAttachmentAlertBanner(config) {
            let openConfig = {
                bindToController: true,
                controller: class BannerPanel {
                    constructor(mdPanelRef, $translate) {
                        'ngInject';
                        this.mdPanelRef = mdPanelRef;
                        this.$translate = $translate;

                        //translation
                        this.description = this.$translate.instant('icm-outreach__email-banner--attachment-failed--message');
                        this.dismissButton = this.$translate.instant('icm-outreach__email-banner--attachment-failed--dismiss-button');
                    }

                    close() {
                        this.mdPanelRef.close();
                    }
                },
                template: `
                <mw-banner type="\'alert\'" on-close="$ctrl.close($event)">
                {{$ctrl.description}}
                    <mw-banner-actions>
                        <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.close($event)">
                            {{$ctrl.dismissButton}}
                        </md-button>
                    </mw-banner-actions>
                </mw-banner>`,
                controllerAs: '$ctrl'
            };

            if(config && config.attachTo){
                openConfig.attachTo = config.attachTo;
            }

            if (this.bannerPannelRef) {
                // making sure there is only 1 outreach banner on page
                this.bannerPannelRef.close();
            }
            this.mwBannerService.open(openConfig).then(function (panelRef) {
                this.bannerPannelRef = panelRef;
            }.bind(this));
        }
    }

    angular.module('MW.Influencers.OutreachBannerService', [
        'MW.Configuration',
        'MW.Influencers.SendgridService',
        'mwAppComponents'
    ])
        .service('OutreachBannerService', [
            '$rootScope',
            'mwBannerService',
            'SendgridService',
            '$q',
            '$http',
            '$location',
            '$timeout',
            'NONVERIFY_DOMAINS',
            OutreachBannerService
        ]);
})();